/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Giveaway_EffectInputs */



/**
* | output |
* | --- |
* | "What it did" |
*
* @param {Features_Giveaway_EffectInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const features_giveaway_effect = /** @type {((inputs?: Features_Giveaway_EffectInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Giveaway_EffectInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Что это дало")
	return /** @type {LocalizedString} */ ("What it did")
});